import { gql } from "@apollo/client";

export const GET_SECURITY_ROLES_DETAILS = gql`
  query getSecurityRoles {
    getSecurityRoles {
      message
      data {
        role_id
        role_name
        role_description
      }
    }
  }
`;

// changing this to employee mail since the way config is done right now, if the hrms changes,
// employee ids which we are getting from HRMS will also change
export const ASSIGN_STAFF_ROLE = gql`
  mutation assignSecurityRole($roleId: String!, $email: String!) {
    assignSecurityRole(roleId: $roleId, email: $email) {
      message
    }
  }
`;
